import { Identity } from "./identity";

export class IdentityResult {
    constructor(
        public identity: Identity = null,
        public tenantId: number = null,
        public locationId: number = null,
        public featureFlags: string[] = []
    ) {
    }
}
